import { inject } from "@angular/core";
import { CanMatchFn, Router } from "@angular/router";
import { AuthStorage } from "../auth/storage/auth-storage";
import { readSession } from "../shared/utils/session.util";

export const loginGuard: CanMatchFn = () => {
  const router = inject(Router);
  const authStorage = inject(AuthStorage);

  if (authStorage.user() || readSession()) {
    return router.createUrlTree(["/admin/dashboard"]);
  }
  return true;
};
